import {
    ApiParameter,    
    HasPagingParameters,    
    post,   
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import {VmiBinModel } from "@insite/client-framework/Types/ApiModels";
import {
    BasePdfApiParameter,   
} from "@insite/client-framework/Types/PrintPdfModels";

const vmiLocationBinsUrl = "api/v2/vmiLocations/{vmiLocationId}/bins";

export interface AddVmiBinApiParameter extends ApiParameter {
    vmiLocationId: string;
    vmiBin: Partial<VmiBinModel>;
}

export interface GetVmiBinApiParameter extends ApiParameter {
    vmiLocationId?: string;
    vmiBinId?: string;
    expand?: "product"[];
}

export interface UpdateVmiBinApiParameter extends ApiParameter {
    vmiBin: VmiBinModel;
}

export interface AddVmiBinCollectionApiParameter extends ApiParameter {
    vmiLocationId: string;
    vmiBins: VmiBinModel[];
}

export interface GetVmiBinsApiParameter extends ApiParameter, HasPagingParameters {
    vmiLocationId?: string;
    filter?: string;
    binNumberFrom?: string;
    binNumberTo?: string;
    previousCountFromDate?: string;
    previousCountToDate?: string;
    metric?: string;
    isBelowMinimum?: boolean;
    numberOfTimesMinQtyReached?: number;
    numberOfPreviousOrders?: number;
    numberOfVisits?: number;
    expand?: "product"[];
}

export interface GetVmiBinCountApiParameter extends ApiParameter {
    isBelowMinimum?: boolean;
    numberOfPreviousOrders?: number;
    numberOfTimesMinQtyReached?: number;
    numberOfVisits?: number;
    vmiLocationId?: string;
}

export interface DeleteVmiBinsApiParameter extends ApiParameter {
    vmiLocationId: string;
    ids: string[];
}
export interface SendVmiBinPdfApiParameter extends BasePdfApiParameter, GetVmiBinsApiParameter {
    vmiBinDetailsPageUrl: string;
}

export async function sendPdf(parameter: SendVmiBinPdfApiParameter): Promise<ServiceResult<any>> {
    const email=parameter?.additionalQueryStringParameters?.email;
    try {
        const result = await post(
            `${vmiLocationBinsUrl.replace("{vmiLocationId}", parameter.vmiLocationId ?? "")}/send-pdf?email=${email}`,
            parameter,
        );
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}